export function PlatformInformation() {
  return (
    <div className="mx-auto w-full max-w-[600px] space-y-2 px-2 pt-6 text-center text-xs leading-relaxed text-gray-500">
      <p>
        The "Availability" means the ratio of actual uptime (i.e., uptime less
        downtime) to the uptime during which the SaaS Services can be used
        (including in cases of occurrence of{' '}
        <span className="whitespace-nowrap">Error Class 2</span> but excluding{' '}
        <span className="whitespace-nowrap">Error Class 1</span>). Coordinated
        Maintenance Windows are not considered when determining availability,
        i.e., they have no influence on availability. Please refer to your
        contractual documents for more information.
      </p>
    </div>
  );
}
